/**
 * Sympl Fire Emoji Remover - AGGRESSIVE VERSION
 * Specifically targets sympl-widget custom element and removes fire emoji
 */

(function() {
  'use strict';

  console.log('🎯 Sympl Fire Emoji Remover: Initializing...');

  // Function to aggressively remove fire emoji from any element
  function removeFireEmojiFromElement(element) {
    if (!element) return false;

    let removed = false;

    // Method 1: Walk through all text nodes
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while (node = walker.nextNode()) {
      if (node.nodeValue && node.nodeValue.includes('🔥')) {
        node.nodeValue = node.nodeValue.replace(/🔥/g, '');
        removed = true;
      }
    }

    // Method 2: Check and replace innerHTML
    if (element.innerHTML && element.innerHTML.includes('🔥')) {
      element.innerHTML = element.innerHTML.replace(/🔥/g, '');
      removed = true;
    }

    // Method 3: Check shadow DOM if exists
    if (element.shadowRoot) {
      removeFireEmojiFromElement(element.shadowRoot);
    }

    return removed;
  }

  // Main cleaning function
  function cleanSymplWidgets() {
    let cleanCount = 0;

    // Target 1: sympl-widget custom elements
    const symplWidgets = document.querySelectorAll('sympl-widget');
    symplWidgets.forEach(widget => {
      if (removeFireEmojiFromElement(widget)) {
        cleanCount++;
      }

      // Also check shadow root
      if (widget.shadowRoot) {
        if (removeFireEmojiFromElement(widget.shadowRoot)) {
          cleanCount++;
        }
      }
    });

    // Target 2: Any element with sympl in class or id
    const symplElements = document.querySelectorAll('[class*="sympl"], [class*="Sympl"], [id*="sympl"], [id*="Sympl"]');
    symplElements.forEach(element => {
      if (removeFireEmojiFromElement(element)) {
        cleanCount++;
      }
    });

    // Target 3: Nuclear option - scan entire body for fire emojis
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      // Skip script and style tags
      if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE') return;

      // Check direct text content
      Array.from(element.childNodes).forEach(child => {
        if (child.nodeType === 3 && child.nodeValue && child.nodeValue.includes('🔥')) {
          child.nodeValue = child.nodeValue.replace(/🔥/g, '');
          cleanCount++;
        }
      });
    });

    if (cleanCount > 0) {
      console.log(`✅ Sympl Fire Emoji Remover: Removed ${cleanCount} instances`);
    }

    return cleanCount;
  }

  // Run immediately
  cleanSymplWidgets();

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('📄 DOM Ready - Cleaning Sympl widgets...');
      cleanSymplWidgets();
    });
  } else {
    cleanSymplWidgets();
  }

  // Run after window load
  window.addEventListener('load', function() {
    console.log('🪟 Window Loaded - Cleaning Sympl widgets...');
    cleanSymplWidgets();

    // Run multiple times to catch lazy-loaded content
    const delays = [100, 300, 500, 1000, 2000, 3000, 5000];
    delays.forEach(delay => {
      setTimeout(() => {
        console.log(`⏱️ Delayed clean (${delay}ms)...`);
        cleanSymplWidgets();
      }, delay);
    });
  });

  // MutationObserver for dynamic content
  const observer = new MutationObserver(function(mutations) {
    let hasSymplChanges = false;

    mutations.forEach(function(mutation) {
      // Check for added nodes
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if it's a sympl-widget or has sympl-widget children
            if (node.tagName === 'SYMPL-WIDGET' || node.querySelector('sympl-widget')) {
              hasSymplChanges = true;
            }

            // Check if it contains fire emoji
            if (node.textContent && node.textContent.includes('🔥')) {
              hasSymplChanges = true;
            }

            // Check for sympl in class or id
            if (node.className?.toLowerCase().includes('sympl') ||
                node.id?.toLowerCase().includes('sympl')) {
              hasSymplChanges = true;
            }
          }
        });
      }

      // Check for text changes
      if (mutation.type === 'characterData' && mutation.target.nodeValue?.includes('🔥')) {
        hasSymplChanges = true;
      }
    });

    if (hasSymplChanges) {
      console.log('🔄 Sympl content detected - Cleaning...');
      setTimeout(cleanSymplWidgets, 50);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'id']
  });

  // Also observe on scroll (for lazy loading)
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(cleanSymplWidgets, 100);
  }, { passive: true });

  // Expose global API
  window.SymplFireEmojiRemover = {
    clean: cleanSymplWidgets,
    cleanElement: removeFireEmojiFromElement
  };

  console.log('✅ Sympl Fire Emoji Remover: Active and monitoring');
})();
